var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RecordingTreeView"},[_c('ul',{staticClass:"RecordingTreeList",attrs:{"id":"demo"}},_vm._l((_vm.treeData),function(item){return _c('RecordingTreeItem',{staticClass:"item",attrs:{"recording":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }